export type Dataset = {
  identifier: string;
  formatedTitle: string;
  group: string;
  title: string;
  unit: string;
};

export type ChartType =
  | "BASIC"
  | "BAR"
  | "BOX"
  | "HISTOGRAM"
  | "PIE"
  | "SCATTER"
  | "STATS"
  | "LINE"
  | "RAW"
  | "MULTISCATTER";

export const ChartTypes = {
  LINE: "Line Chart",
  BAR: "Bar Chart",
  BOX: "Box Chart",
  PIE: "Pie Chart",
  SCATTER: "Scatter Chart",
  MULTISCATTER: "Multi Scatter Chart",
  HISTOGRAM: "Histogram Chart",
  STATS: "Statistics",
  RAW: "Raw Data Table",
};

export type DatasetAxis = {
  identifier: string;
  formatedTitle: string;
  group: string;
  title: string;
  unit: string;
  axis: Axis;
  currentLineConfig: {
    color: string;
    width: number;
    dashType: string;
    range: {
      min: number | undefined;
      max: number | undefined;
    };
  };
};

export type Axis = "X" | "Y" | "none" | "color" | "size";

export type AxisAssignedArrays = {
  none: Array<JSX.Element>;
  X: Array<JSX.Element>;
  Y: Array<JSX.Element>;
  size?: Array<JSX.Element>;
  color?: Array<JSX.Element>;
};

export type ChartData = {
  id: string;
  title: string;
  unit: string;
  stringValueMapper?: number;
  keyArr: Array<Date | number>;
  valueArr: Array<number>;
  decimalPlaces?: number;
  valuesToDisplay?: Array<number | string>;
};

export type AggregationType = "SUM" | "AVG" | "none";
